export class SCORM_CONST {
  public static V_1_DOT_2 = '1.2';
  public static NULL = 'null';
  public static PASSED = 'passed';
  public static FAILED = 'failed';
  public static COMPLETE = 'completed';
  public static INCOMPLETE = 'incomplete';
  public static EXIT = 'exit';
  public static EXIT_ALL = 'exitAll';
  public static CMI = 'cmi';

  public static CMI_SESSION_TIME = `${SCORM_CONST.CMI}.session_time`;
  public static CMI_SUSPEND_DATA = `${SCORM_CONST.CMI}.suspend_data`;
  public static CMI_LOCATION = `${SCORM_CONST.CMI}.location`;
  public static CMI_COMPLETION_STATUS = `${SCORM_CONST.CMI}.completion_status`;
  public static CMI_SUCCESS_STATUS = `${SCORM_CONST.CMI}.success_status`;
  public static CMI_LEARNER_ID = `${SCORM_CONST.CMI}.learner_id`;
  public static CMI_SCALED_PASSING_SCORE = `${SCORM_CONST.CMI}.scaled_passing_score`;

  public static CMI_SCORE = `${SCORM_CONST.CMI}.score`;
  public static CMI_SCORE_SCALED = `${SCORM_CONST.CMI_SCORE}.scaled`;
  public static CMI_SCORE_RAW = `${SCORM_CONST.CMI_SCORE}.raw`;
  public static CMI_SCORE_MIN = `${SCORM_CONST.CMI_SCORE}.min`;
  public static CMI_SCORE_MAX = `${SCORM_CONST.CMI_SCORE}.max`;

  public static CMI_CORE = `${SCORM_CONST.CMI}.core`;
  public static CMI_CORE_SESSION_TIME = `${SCORM_CONST.CMI_CORE}.session_time`;
  public static CMI_CORE_LESSON_STATUS = `${SCORM_CONST.CMI_CORE}.lesson_status`;
  public static CMI_CORE_STUDENT_ID = `${SCORM_CONST.CMI_CORE}.student_id`;
  public static CMI_CORE_SCORE = `${SCORM_CONST.CMI_CORE}.score`;
  public static CMI_CORE_SCORE_MIN = `${SCORM_CONST.CMI_CORE_SCORE}.min`;
  public static CMI_CORE_SCORE_MAX = `${SCORM_CONST.CMI_CORE_SCORE}.max`;
  public static CMI_CORE_SCORE_RAW = `${SCORM_CONST.CMI_CORE_SCORE}.raw`;

  public static ADL = 'adl';
  public static ADL_NAV = `${SCORM_CONST.ADL}.nav`;
  public static ADL_NAV_REQUEST = `${SCORM_CONST.ADL_NAV}.request`;


  public static KB4_THEME = 'kb4.theme';
  public static KB4_ACCOUNT_INFO = 'kb4.info';
}

export class LOCK_CONST {
  public static UNLOCKED = 0;
  public static FORWARD_LOCKED = 1;
  public static TOTALLY_LOCKED = 2;
}

export class STORE_CONST {
  public static APP_MODULE_NAME = 'app';
  public static USER_CONF_MODULE_NAME = 'userConf';
  public static THEME_CONF_MODULE_NAME = 'theme';
}

export class SKIP_CONST {
  public static NO_SKIP = 'no-skip';
  public static VIDEO_SKIP = 'video-skip';
}

export class TEST_OUT_EVENTS {
  public static BTB_PREFIX = 'btb_'
  public static REQUESTED = `${TEST_OUT_EVENTS.BTB_PREFIX}test_out_requested`;
  public static FAILED = `${TEST_OUT_EVENTS.BTB_PREFIX}test_out_failed`;
  public static SUCCESS = `${TEST_OUT_EVENTS.BTB_PREFIX}test_out_success`;
}

export const CUSTOM_TERM_FILTER = '| customTerm'; 